module.exports = __webpack_public_path__ + "img/work_better1.9e4b86af.png";